import { render, staticRenderFns } from "./ButtonsTooltip.vue?vue&type=template&id=2066ac9e&scoped=true"
import script from "./ButtonsTooltip.vue?vue&type=script&lang=js"
export * from "./ButtonsTooltip.vue?vue&type=script&lang=js"
import style0 from "./ButtonsTooltip.vue?vue&type=style&index=0&id=2066ac9e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2066ac9e",
  null
  
)

export default component.exports